export default "__VITE_ASSET__CKdaTrtr__"